module.exports = __webpack_public_path__ + "static/media/arrow-back-ios.f111b767.svg";